import * as React from "react";
// react-bootstrap components
import { Button } from "react-bootstrap";

function CustomSeverity({ value }) {
  let type = "status-neutral";
  let title = "N/A";

  if (value !== null && value !== undefined) {
    if (value === 0) {
      type = "status-success";
      title = "No Issue";
    } else if (value === 1) {
      type = "status-warning";
      title = "Minor Issue";
    } else {
      type = "status-danger";
      title = "Major Issue";
    }
  }
  return (
    <Button variant={type} className="btn-status">
      {title}
    </Button>
  );
}

export default CustomSeverity;
